import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.Description.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CheckableFieldDescription = _a => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  const {
    id,
    description,
    validationMessage
  } = useContext(CheckableFieldContext);
  if (!description || validationMessage) {
    return null;
  }
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    id: "".concat(id, "-description"),
    className: clsx("pd:checkable-field__description", className)
  }, rest), {
    children: description
  }));
};
var CheckableField_Description_default = CheckableFieldDescription;
export { CheckableField_Description_default };